import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  onSelect: (comic: Comic) => void;
}

export default function ComicCard({ comic, onSelect }: ComicCardProps) {
  return (
    <button
      type="button"
      onClick={() => onSelect(comic)}
      className="group block w-full text-left cursor-pointer"
      aria-label={`查看《${comic.title}》详情`}
    >
      <div className="relative overflow-hidden rounded-xl bg-background-200 aspect-[2/3]">
        <img
          src={comic.cover}
          alt={`${comic.title}高清韩国漫画封面`}
          title={`${comic.title} 高清韩漫`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <span className="absolute top-2.5 left-2.5 px-2.5 py-0.5 rounded-full bg-background-50/90 text-xs font-medium text-foreground-800">
          {comic.category}
        </span>
        <span className="absolute top-2.5 right-2.5 px-2 py-0.5 rounded-md bg-primary-500 text-xs font-bold text-background-50">
          {comic.rating}
        </span>
        <div className="absolute inset-x-2.5 bottom-2.5 flex items-center justify-between text-xs text-background-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span>共 {comic.chapterCount} 话</span>
          <span>{comic.status}</span>
        </div>
      </div>
      <h3 className="mt-2.5 font-semibold text-sm md:text-base text-foreground-950 leading-snug truncate">
        {comic.title}
      </h3>
      <p className="mt-1 text-xs text-foreground-500 truncate">
        {comic.author} · {comic.chapterCount}话 · {comic.views}阅读
      </p>
    </button>
  );
}